import actionTypes from 'redux/actions/actionTypes';
import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';
import initialState from 'redux/initialState';

const updateSocietyShares = (society, action) => {
  const { societyShares } = action;

  return {
    ...society,
    actualSociety: { ...society.actualSociety, sharesCount: societyShares },
  };
};

const updateSocietyPartnersCount = (society, action) => {
  const { societyPartnersCount } = action;

  return {
    ...society,
    actualSociety: {
      ...society.actualSociety,
      partnersCount: societyPartnersCount,
    },
  };
};

const updateSocietyHoldingClassesCount = (society, action) => {
  const { holdingClassesCount } = action;

  return {
    ...society,
    actualSociety: {
      ...society.actualSociety,
      holdingClassesCount,
    },
  };
};

const updateSocietyData = (society, action) => {
  const { societyData } = action;

  return {
    ...society,
    actualSociety: {
      ...society.actualSociety,
      ...societyData,
    },
  };
};

export default function reducer(society = initialState.society, action) {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return initialState.society;

    case actionTypes.SET_SOCIETY:
      return {
        actualSociety: action.society.society,
        permissions: action.society.permissions,
        role: action.society.role,
      };

    case actionTypes.UPDATE_SOCIETY:
      return { ...society, actualSociety: action.society };

    case actionTypes.UPDATE_SOCIETY_SHARES:
      return updateSocietyShares(society, action);

    case actionTypes.UPDATE_SOCIETY_DATA:
      return updateSocietyData(society, action);

    case actionTypes.UPDATE_SOCIETY_PARTNERS_COUNT:
      return updateSocietyPartnersCount(society, action);

    case actionTypes.UPDATE_HOLDING_CLASSES_COUNT:
      return updateSocietyHoldingClassesCount(society, action);

    case actionTypes.DELETE_SOCIETY:
      return initialState.society;

    default:
      return society;
  }
}
